var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFooterLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4498 20.4497H16.8936V14.8805C16.8936 13.5525 16.8699 11.843 15.0441 11.843C13.1919 11.843 12.9085 13.2898 12.9085 14.7838V20.4492H9.35238V8.99688H12.7662V10.5619H12.8141C13.5092 9.37346 14.8064 8.66098 16.1825 8.71207C19.7867 8.71207 20.4513 11.0828 20.4513 14.1671L20.4498 20.4497ZM5.33983 7.43138C5.33962 7.43138 5.3395 7.43138 5.3394 7.43138C4.20728 7.43138 3.27569 6.4999 3.27569 5.36778C3.27569 4.23567 4.20728 3.30408 5.3394 3.30408C6.47141 3.30408 7.40289 4.23545 7.4031 5.36736C7.4031 5.36746 7.4031 5.36757 7.4031 5.36778C7.4031 6.49969 6.47173 7.43128 5.33983 7.43138ZM7.11788 20.4497H3.55802V8.99688H7.11788V20.4497ZM22.2226 0.00165575H1.77096C0.810928 -0.00918665 0.0117012 0.771465 0 1.7315V22.2681C0.0112718 23.2287 0.810391 24.0102 1.77096 23.9999H22.2226C23.1856 24.012 23.9875 23.2306 24.0004 22.2681V1.7301C23.9875 0.768029 23.1845 -0.0125153 22.2226 0.000152033V0.00165575Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFooterLinkedin);
export default __webpack_public_path__ + "static/media/icon-footer-linkedin.042e2f9b9c5a20f017d7d72df7f2a25c.svg";
export { ForwardRef as ReactComponent };